"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withEmptyView = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmptyChart = function EmptyChart(props) {
  var width = props.width,
    height = props.height,
    margin = props.margin;

  // Check if the margins are set, if one side is not set try to set it to the opposite, if both aren't, use 0
  var left = margin.left || margin.right || 0,
    right = margin.right || margin.left || 0,
    top = margin.top || margin.bottom || 0,
    bottom = margin.bottom || margin.top || 0;
  var xCenter = (width - left - right) / 2 + left;
  var yCenter = (height - top - bottom) / 2 + top;
  var text = width - left - right < 200 ? "Nothing to Show" : "Too Little Data to Show Anything";
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(".concat(xCenter, ",").concat(yCenter, ")")
  }, /*#__PURE__*/_react.default.createElement("text", {
    textAnchor: "middle",
    fontSize: "0.9em"
  }, text)));
};
EmptyChart.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin
};
EmptyChart.defaultProps = {
  width: 400,
  height: 400,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  }
};
var _default = EmptyChart;
exports.default = _default;
var withEmptyView = function withEmptyView(WrappedComponent) {
  var ChartWithEmptyView = function ChartWithEmptyView(props) {
    return props.data && props.data.length > 0 ? /*#__PURE__*/_react.default.createElement(WrappedComponent, props) : /*#__PURE__*/_react.default.createElement(EmptyChart, props);
  };
  ChartWithEmptyView.propTypes = {
    data: _propTypes.default.array,
    width: _propTypes.default.number,
    height: _propTypes.default.number,
    margin: _propTypes2.propTypeMargin
  };
  return ChartWithEmptyView;
};
exports.withEmptyView = withEmptyView;